import styled from 'styled-components';

import {Pill, Pills} from 'components/ui-kit/Pills';
import {Title} from 'components/ui-kit/Title';
import {breakpoint, colors} from 'theme';

export const NavigationContainer = styled.div`
    display: flex;
    flex-flow: column nowrap;
    background-color: #ffffff;
    border-radius: 8px;
    padding: 15px 30px 0;
`;

export const Heading = styled.div`
    display: flex;
    flex-flow: column nowrap;
    justify-content: space-between;

    @media (min-width: ${breakpoint.phone}) {
        flex-flow: row wrap;
    }
`;

export const CustomTitle = styled(Title)`
    color: ${colors.textPrimary};
    font-weight: 500;
    font-size: 18px;
    min-height: 44px;
`;

export const CustomPills = styled(Pills)`
    flex-flow: row nowrap;
    overflow-x: auto;
    margin-top: 40px;
    flex: 1;
    font-size: 13px;
    text-transform: uppercase;
    text-align: center;
    font-weight: bold;

    ${Pill} {
        width: 100%;
        margin-right: 0;
        color: ${colors.textPrimary};
        white-space: nowrap;
        transition: all 0.35s ease;

        &.not-active {
            color: ${colors.textMuted};
            border-bottom: 2px solid ${colors.border};
        }
    }
`;
